import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m6.994 10.327-5.439 13.44a.75.75 0 0 1-.268.327.7.7 0 0 1-.387.11h-1.747q-.496 0-.655-.437l-5.44-13.44a.62.62 0 0 1 .06-.656.67.67 0 0 1 .575-.317h6.63q.28 0 .487.209.21.207.209.506v1.45a.7.7 0 0 1-.209.505.67.67 0 0 1-.486.209h-3.335l3.037 7.643 3.99-10.085q.16-.436.656-.437h1.667a.64.64 0 0 1 .575.317.65.65 0 0 1 .08.656",
      "shape-rendering": "geometricPrecision"
    }, null, -1)
  ])))
}
export default { render: render }